<template>
  <div class="analysis">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="代理商" label-width="60px">
        <el-select v-model="searchForm.operator" @change="operatorClick" placeholder="请选择">
          <el-option
              v-for="item in operatorOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="药房" label-width="60px">
        <el-select v-model="searchForm.pharmacy" @change="init" filterable  placeholder="请选择">
          <el-option
              v-for="item in pharmacyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开药人员工号" label-width="100px">
        <el-input style="width: 140px"  clearable v-model="searchForm.workerNumber" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="处方号" label-width="70px">
        <el-input style="width: 140px"  clearable v-model="searchForm.prescriptionNumber" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="门诊号" label-width="70px">
        <el-input style="width: 140px"  clearable v-model="searchForm.clinicNo" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="病人身份证号码" label-width="120px">
        <el-input style="width: 140px"  clearable v-model="searchForm.IdCard" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="患者姓名" label-width="70px">
        <el-input style="width: 140px"  clearable v-model="searchForm.patientName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="物流号" label-width="70px">
        <el-input style="width: 140px"  clearable v-model="searchForm.logisticsNumber" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="病例号" label-width="70px">
        <el-input style="width: 140px"  clearable v-model="searchForm.caseNumber" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="日期区间" label-width="70px">
        <el-date-picker
            v-model="searchForm.time"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="createTime"
            label="创建时间"
            min-width="70">
        </el-table-column>
        <el-table-column
            prop="deviceCode"
            label="设备编号"
            align="center">
        </el-table-column>
        <el-table-column
            prop="clinicNO"
            align="center"
            label="门诊号">
        </el-table-column>
        <el-table-column
            prop="name"
            align="center"
            label="患者姓名">
        </el-table-column>
        <el-table-column
            prop="gender"
            align="center"
            label="性别">
        </el-table-column>
        <el-table-column
            prop="workNumber"
            align="center"
            label="发药人工号">
        </el-table-column>
        <el-table-column
            prop="workerName"
            align="center"
            label="发药人姓名">
        </el-table-column>
        <el-table-column
            prop="days"
            align="center"
            label="处方天数">
        </el-table-column>
        <el-table-column
            prop="price"
            align="center"
            label="单价">
        </el-table-column>
        <el-table-column
            prop="sumCost"
            align="center"
            label="总价">
        </el-table-column>
        <el-table-column
            prop="caseNumber"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button @click="lookClick(scope.row)" type="text" size="small">查看明细</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        title="处方详情"
        :visible.sync="dialogVisible"
        width="90%"
        :before-close="handleClose">
      <div class="flex">
        <div style="border-right: 1px solid #eee;flex: 1;">
          <h1>处方详情</h1>
          <div class="flex flex-wrap detailsList">
            <div class="flex">
              <div>创建时间：</div>
              <div>{{detailsList.createTime}}</div>
            </div>
            <div class="flex">
              <div>处方号：</div>
              <div>{{detailsList.prescriptionNumber}}</div>
            </div>
            <div class="flex">
              <div>设备编号：</div>
              <div>{{detailsList.deviceCode}}</div>
            </div>
            <div class="flex">
              <div>门诊号：</div>
              <div>{{detailsList.clinicNO}}</div>
            </div>
            <div class="flex">
              <div>患者姓名：</div>
              <div>{{detailsList.name}}</div>
            </div>
            <div class="flex">
              <div>发药人工号：</div>
              <div>{{detailsList.workNumber}}</div>
            </div>
            <div class="flex">
              <div>发药人姓名：</div>
              <div>{{detailsList.workerName}}</div>
            </div>
            <div class="flex">
              <div>患者出生日期：</div>
              <div>{{detailsList.birthday}}</div>
            </div>
            <div class="flex">
              <div>性别：</div>
              <div>{{detailsList.gender}}</div>
            </div>
            <div class="flex">
              <div>身份证：</div>
              <div>{{detailsList.idCard}}</div>
            </div>
            <div class="flex">
              <div>处方天数：</div>
              <div>{{detailsList.days}}</div>
            </div>
            <div class="flex">
              <div>单价：</div>
              <div>{{detailsList.price}}</div>
            </div>
            <div class="flex">
              <div>总价：</div>
              <div>{{detailsList.sumCost}}</div>
            </div>
            <div class="flex">
              <div>服用方法：</div>
              <div>{{detailsList.takingMethod}}</div>
            </div>
            <div class="flex">
              <div>医嘱：</div>
              <div>{{detailsList.doctorInstructions}}</div>
            </div>
            <div class="flex">
              <div>症状：</div>
              <div>{{detailsList.symptom}}</div>
            </div>
            <div class="flex">
              <div>物流号：</div>
              <div>{{detailsList.logisticsNumber}}</div>
            </div>
            <div class="flex">
              <div>病例号：</div>
              <div>{{detailsList.caseNumber}}</div>
            </div>
            <div class="flex">
              <div>住院号：</div>
              <div>{{detailsList.inPatientNumber}}</div>
            </div>
            <div class="flex">
              <div>床号：</div>
              <div>{{detailsList.bedNumber}}</div>
            </div>
            <div class="flex">
              <div>分方数值：</div>
              <div>{{detailsList.divideNumber}}</div>
            </div>
            <div class="flex">
              <div>药杯数：</div>
              <div>{{detailsList.cups}}</div>
            </div>
            <div class="flex">
              <div>药杯规格：</div>
              <div>{{detailsList.cupType}}</div>
            </div>
          </div>
        </div>
        <div style="padding-left: 20px;flex: 1">
          <h1>处方明细</h1>
          <div>
            <el-table
                :data="moreList"
                max-height="600"
                style="width: 100%;margin-top: 5px">
              <el-table-column
                  prop="drugName"
                  label="药名"
                  width="180">
              </el-table-column>
              <el-table-column
                  prop="drugCode"
                  label="药品编码"
                  width="180">
              </el-table-column>
              <el-table-column
                  prop="dose"
                  label="剂量">
              </el-table-column>
              <el-table-column
                  prop="unit"
                  label="药品单位">
              </el-table-column>
              <el-table-column
                  prop="createTime"
                  label="创建时间">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">关闭</el-button>
        <!--    <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>-->
  </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import DicInput from '@/components/DicInput.vue';
import {GetUrl,getDay} from "@/service/common";
export default {
  name: "analysis",
  data() {
    return {
      tableData: [],
      searchForm: {
        workNumber: '',
        prescriptionNumber: '',
        clinicNo: '',
        IdCard: '',
        patientName: '',
        logisticsNumber: '',
        caseNumber: '',
        pharmacy:'',
        time:[]
      },
      detailsList:[],
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      dialogVisible: false,
      rules: [],
      operatorOptions:[],
      pharmacyOptions:[],
      userJson: {},
      moreList: [],
      options: [],
    }
  },
  components: {
    //someComponent
    Pagination,
    DicInput
  },
  created() {
    this.userJson = window.utils.storage.getter('userJson')
  },
  methods: {
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.searchForm = {
        workNumber: '',
        prescriptionNumber: '',
        clinicNo: '',
        IdCard: '',
        patientName: '',
        logisticsNumber: '',
        caseNumber: '',
        time:[]
      }
      this.init()
    },
    // 明细
    lookClick(row) {
      this.detailsList=row
      let data={
        prescriptionNumber:row.prescriptionNumber,
        createTime:row.createTime
      }
      this.axios.get('/api/Prescription/Detail',{params: data}).then(res=>{
        this.moreList=res.list
      })
      this.dialogVisible = true
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.ruleForm,
            "pharmacyId": this.userJson.pharmacyId,
            "operatorId": this.userJson.operatorId,
          }
          this.axios
              .post('/api/ExceptionRecord/newException', data)
              .then((res) => {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.init()
                this.$refs[formName].resetFields();
                this.dialogVisible = false
              })
        } else {
          return false;
        }
      });
    },
    //弹窗模块
    handleClose(done) {
      done();
    },
    operatorList(){
      this.axios
          .get('/api/Dic?dicType=6')
          .then((res) => {
            this.operatorOptions=res
            this.operatorOptions.forEach(item=>{
              item.label=item.name
              item.value=item.id
            })
          })
    },
    operatorClick(e){
      let data={
        operatorId:e,
        page:'1',
        pageSize:'2000'
      }
      this.axios
          .get('/api/Pharmacy/GetByOperator',{params:data}).then((res) => {
        this.pharmacyOptions=res.list
        this.pharmacyOptions.forEach(item=>{
          item.label=item.name
          item.value=item.id
        })
      })
    },
    // list
    init() {
      if(this.searchForm.pharmacy===''){
        return
      }
      let data = {
        ...this.searchForm,
        pharmacyId: this.searchForm.pharmacy,
        'startTime':this.searchForm.time[0]?this.searchForm.time[0]:getDay(-1,'-'),
        'endTime':this.searchForm.time[1]?this.searchForm.time[1]:getDay(-0,'-'),
        page:this.currPage,
        pageSize:this.pageSize
      }
      delete data.time
      this.axios
          .get("/api/Prescription/GetByInfos", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.tableData.forEach(item=>{
              switch (item.gender) {
                case 1:
                  item.gender = '男'
                  break;
                case 2:
                  item.gender = '女'
                  break;
                default :
                  item.gender = '未知'
              }
              this.tableData.forEach(item=>{
                if(item.createTime){
                  item.createTime=this.dayjs(item.createTime).format('YYYY/MM/DD HH:mm')
                }
              })
            })
            this.total = res.count
          })
    },
  },
  mounted() {
    //
    this.operatorList()
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.analysis {
  .detailsList{
    flex-wrap: wrap;
    padding-top: 10px;
  }
  .detailsList >div{
    width: 50%;
    padding-bottom: 10px;
    &>div{
      &:nth-child(1){
        text-align: right;
        width: 100px;
        font-weight: bold;
      }
      &:nth-child(2){
        color: #494848;
      }
    }

  }
}
</style>